import { SectionConfigBuilder } from '../ThemeConfigBuilder';
import { body, headline, overline } from '../fields/fields';

export default new SectionConfigBuilder()
  .setContext('picker', {
    label: 'Search Input',
    description: 'Displays input field for post search',
    icon: 'Post',
  })
  .setContext('editor', {
    label: 'Search Input Section',
    description: '',
    icon: 'Post',
  })
  .addLayout('layout1', (layout) => {
    layout
      .setDescription('Search input only')
      .setIcon('PostLayout6')
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setActions(0);
      })
      .addBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setActions(0);
      });
  })
  .build();
